"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrDesktopNavLink = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_basis_bs_icon_1 = require("@hotelplan/core.basis.bs-icon");
const fdr_regular_basis_fdr_route_1 = require("@hotelplan/fdr.regular.basis.fdr-route");
const supergraph_api_1 = require("@hotelplan/supergraph-api");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const SubMenuChevron = (0, styled_components_1.default)(core_basis_bs_icon_1.BsIcon)((0, util_theme_sxc_1.sx2CssThemeFn)({
    ml: [1, 2],
    flexShrink: '0',
}));
const Link = (0, styled_components_1.default)(fdr_regular_basis_fdr_route_1.FdrRoute)(({ fontColor }) => fontColor ? { color: `${fontColor}` } : {});
const FdrDesktopNavLink = ({ item, isSubMenu, internalLinkIconName, onClick, onLinkInteraction, }) => {
    var _a;
    const link = item.link;
    const className = isSubMenu
        ? `sub-menu-item`
        : `menu-link-item ${'menuItems' in item && ((_a = item === null || item === void 0 ? void 0 : item.menuItems) === null || _a === void 0 ? void 0 : _a.length) > 0
            ? 'main-menu-chevron'
            : null}`;
    return (react_1.default.createElement("li", { className: className, "data-id": isSubMenu ? 'sub-menu-link' : 'main-menu-link' },
        react_1.default.createElement(Link, { link: link, className: isSubMenu ? 'sub-menu-link' : 'nav-link', onClick: onClick, fontColor: item === null || item === void 0 ? void 0 : item.fontColor, onMouseEnter: onLinkInteraction, onFocus: onLinkInteraction },
            item.caption,
            isSubMenu && (react_1.default.createElement(SubMenuChevron, { className: "sub-link-chevron", name: item.iconType === supergraph_api_1.FdrMenuIconType.External
                    ? `external-link`
                    : internalLinkIconName })))));
};
exports.FdrDesktopNavLink = FdrDesktopNavLink;
//# sourceMappingURL=fdr-desktop-nav-link.js.map